import React from "react";
import { MessageOutlined } from "@ant-design/icons";
import type { ReactNode } from "react";

/** Icon and style per action code (for picker and nodes) - same pattern as conditionCodeMapping */
const CODE_ICON_MAP: Record<string, { icon: ReactNode }> = {
    "Action.Message.AutomatedResponse": {
        icon: React.createElement("div", { className: "automationIconsSprite automated-response-icon" }),
    },
    "Action.Notify.NotifyUser": {
        icon: React.createElement("div", { className: "automationIconsSprite notify-user-icon" }),
    },
    "Action.Crm.CreateLead": {
        icon: React.createElement("div", { className: "automationIconsSprite create-lead-icon" }),
    },
    "Action.Crm.LogActivity": {
        icon: React.createElement("div", { className: "automationIconsSprite log-activity-icon" }),
    },
    "Action.Crm.AddNote": {
        icon: React.createElement("div", { className: "automationIconsSprite add-note-icon" }),
    },
    "Action.FlowControl.Delay": {
        icon: React.createElement("div", { className: "automationIconsSprite delay-icon" }),
    },
};

/** Legacy form type to action code for icon lookup */
const FORM_TYPE_TO_CODE: Record<string, string> = {
    AutomatedResponse: "Action.Message.AutomatedResponse",
    NotifyUser: "Action.Notify.NotifyUser",
    CreateLead: "Action.Crm.CreateLead",
    LogActivity: "Action.Crm.LogActivity",
    AddNote: "Action.Crm.AddNote",
    Delay: "Action.FlowControl.Delay",
};

export function getActionIconAndClass(codeOrFormType: string | undefined): { icon: ReactNode } {
    const code = codeOrFormType?.startsWith("Action.") ? codeOrFormType : FORM_TYPE_TO_CODE[codeOrFormType ?? ""];
    return CODE_ICON_MAP[code ?? ""] ?? { icon: React.createElement(MessageOutlined) };
}

/**
 * Maps API action codes to internal form identifiers.
 * Used to select which config form to render for each action type.
 */
export const ACTION_CODE_TO_FORM_TYPE: Record<string, string> = {
    "Action.Message.AutomatedResponse": "AutomatedResponse",
    "Action.Notify.NotifyUser": "NotifyUser",
    "Action.Crm.AddNote": "AddNote",
    "Action.Crm.LogActivity": "LogActivity",
    "Action.Crm.CreateLead": "CreateLead",
    "Action.FlowControl.Delay": "Delay",
};

export const ACTION_CODE_TO_TITLE: Record<string, string> = {
    "Action.Message.AutomatedResponse": "Automated Response",
    "Action.Notify.NotifyUser": "Notify User",
    "Action.Crm.AddNote": "Add Note",
    "Action.Crm.LogActivity": "Log Activity",
    "Action.Crm.CreateLead": "Create Lead",
    "Action.FlowControl.Delay": "Delay",
};

export function actionCodeToTitle(code: string | undefined): string | undefined {
    return code ? ACTION_CODE_TO_TITLE[code] : undefined;
}

export function getFormTypeForAction(codeOrType: string): string {
    if (ACTION_CODE_TO_FORM_TYPE[codeOrType]) {
        return ACTION_CODE_TO_FORM_TYPE[codeOrType];
    }
    return codeOrType;
}
